import { AgingTable } from "@/components/accounting/aging-table";
import { useBreadcrumbs } from "@/lib/use-breadcrumbs";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/accounting/payables")({
	component: PayablesPage,
});

function PayablesPage() {
	const { t } = useTranslation("accounting");
	useBreadcrumbs([{ label: t("nav_payables") }]);
	return <AgingTable accountPrefix="60" titleKey="ap_aging_title" />;
}
